export type PeerInfo = { peerId: string; displayName?: string; deviceName?: string };

export function diffPeers(
  prev: PeerInfo[],
  next: PeerInfo[],
): { joined: PeerInfo[]; left: string[] } {
  const prevIds = new Set(prev.map((p) => p.peerId));
  const nextIds = new Set(next.map((p) => p.peerId));
  const joined = next.filter((p) => !prevIds.has(p.peerId));
  const left = prev.map((p) => p.peerId).filter((id) => !nextIds.has(id));
  return { joined, left };
}

// Deterministic: the peer with the lexicographically smaller id initiates.
export function isCaller(myPeerId: string, otherPeerId: string): boolean {
  return myPeerId < otherPeerId;
}

export function waitForIceGatheringComplete(
  conn: RTCPeerConnection,
  timeoutMs = 2000,
): Promise<void> {
  if (conn.iceGatheringState === "complete") return Promise.resolve();
  return new Promise<void>((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      conn.removeEventListener("icegatheringstatechange", onChange);
      clearTimeout(timer);
      resolve();
    };
    const onChange = () => {
      if (conn.iceGatheringState === "complete") finish();
    };
    conn.addEventListener("icegatheringstatechange", onChange);
    const timer = setTimeout(finish, timeoutMs);
  });
}
